export enum EnvironmentType {
  development = 'development',
  test = 'test',
  staging = 'staging',
  production = 'production',
}

export class EnvironmentSettings {
  aaptivUserPortalUrl?: string;
  aaptivServiceUrl?: string;
  aaptivApiKey?: string;
  aaptivEnterpriseId?: string;
  adminContentApiUrl?: string;
  appDebug?: boolean;
  firebase?: {
    apiKey: string;
    appId: string;
    authDomain: string;
    measurementId?: string;
    messagingSenderId: string;
    projectId: string;
    storageBucket: string;
  };
  pearStudioLibConfig?: {
    serverTimeUrl: string;
  };
  productionMode: boolean;
  repTime?: number;
  sentryDsn?: string;
  sentryServiceTag?: string;
  serverEnvironment?: EnvironmentType;
  googleAnalyticsTrackingId?: string;
  isAaptiv?: boolean;
  defaultTenantId?: string;
}
